import { NavLink } from "react-router-dom";
import { IconJobs, IconTrack, IconPrep, IconPricing } from "@/components/icons/BrandIcons";
import { cn } from "@/lib/utils";

const TOOLS_ACTIVE_PATHS = ["/tools", "/resume", "/cover-letter"];

function isToolsTabActive(pathname) {
  return TOOLS_ACTIVE_PATHS.includes(pathname) || pathname.startsWith("/tools/");
}

const TABS = [
  { to: "/jobs", label: "Jobs", icon: IconJobs, testId: "jobs", end: false },
  { to: "/track", label: "Track", icon: IconTrack, testId: "track", end: true },
  { to: "/tools", label: "Tools", icon: IconPrep, testId: "tools", end: true, isToolsTab: true },
  { to: "/pricing", label: "Pricing", icon: IconPricing, testId: "pricing", end: true },
];

/**
 * Fixed bottom tab bar for mobile.
 */
export function MobileBottomNav({ trackBadge = 0 }) {
  return (
    <nav
      className={cn(
        "fixed inset-x-0 bottom-0 z-50 md:hidden",
        "border-t border-border/60 bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/90",
        "pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-2 shadow-[0_-4px_24px_rgba(0,0,0,0.05)]"
      )}
      data-testid="mobile-bottom-nav"
      aria-label="Main"
    >
      <div className="mx-auto flex max-w-lg items-stretch justify-around px-1">
        {TABS.map(({ to, label, icon: Icon, testId, end, isToolsTab }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={`mobile-bottom-nav-${testId}`}
            isActive={
              isToolsTab
                ? (_, location) => isToolsTabActive(location.pathname)
                : undefined
            }
            className={({ isActive: active }) =>
              cn(
                "flex min-h-[3.85rem] flex-1 flex-col items-center justify-center gap-1 rounded-lg px-1.5 py-2 text-sm font-medium leading-none transition-colors",
                active ? "text-primary" : "text-muted-foreground hover:text-foreground"
              )
            }
          >
            {({ isActive: active }) => (
              <>
                <span className="relative inline-flex h-8 w-8 items-center justify-center">
                  <Icon
                    className={cn("h-7 w-7", active ? "text-primary" : "text-current")}
                    strokeWidth={active ? 1.85 : 1.5}
                  />
                  {testId === "track" && trackBadge > 0 ? (
                    <span className="absolute -right-2 -top-1.5 flex h-[1.125rem] min-w-[1.125rem] items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold leading-none text-primary-foreground">
                      {trackBadge > 99 ? "99+" : trackBadge}
                    </span>
                  ) : null}
                </span>
                <span className={cn("truncate", active && "font-semibold")}>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
